import { useState } from "react";
import { Link } from "react-router-dom";
import PrivacyModal from "./PrivacyModal";
import { footerCategories, INSTAGRAM_URL, VELLORA_URL, WHATSAPP_URL } from "@/mocks/navigation";

export default function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);

  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-secondary-500/50 bg-primary-800">
                <i className="ri-leaf-line text-base text-secondary-300" />
              </span>
              <span className="font-heading text-3xl font-semibold">Amora Belle</span>
            </div>
            <p className="mt-4 max-w-xs font-heading text-xl italic text-secondary-200">
              Moda para viver cada versão de você.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-xl text-background-50">Categorias</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2">
              {footerCategories.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    className="cursor-pointer whitespace-nowrap text-sm text-background-200 transition-colors hover:text-secondary-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-xl text-background-50">Atendimento</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-background-200">
              <li className="flex items-start gap-3">
                <span className="flex h-5 w-5 items-center justify-center pt-0.5">
                  <i className="ri-whatsapp-line text-base text-secondary-300" />
                </span>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cursor-pointer whitespace-nowrap transition-colors hover:text-secondary-300"
                >
                  WhatsApp: (62) 99802-3960
                </a>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-5 w-5 items-center justify-center pt-0.5">
                  <i className="ri-instagram-line text-base text-secondary-300" />
                </span>
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cursor-pointer whitespace-nowrap transition-colors hover:text-secondary-300"
                >
                  @vellora__studio
                </a>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-5 w-5 items-center justify-center pt-0.5">
                  <i className="ri-map-pin-line text-base text-secondary-300" />
                </span>
                <span>Goiânia — GO · Atendimento digital em todo o Brasil</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-xl text-background-50">Fale com a gente</h4>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              Escolha suas peças com calma e finalize tudo pelo WhatsApp, com atendimento próximo e humano.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-secondary-400"
            >
              <i className="ri-whatsapp-line text-base" />
              Falar no WhatsApp
            </a>
            <Link
              to="/"
              className="mt-3 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-sm text-background-200 transition-colors hover:text-secondary-300"
            >
              <i className="ri-arrow-up-line text-base" />
              Voltar ao início
            </Link>
          </div>
        </div>

        <div className="mt-12 rounded-lg border border-primary-700 bg-primary-800/60 p-5 md:p-6">
          <p className="flex items-start gap-3 text-sm text-background-100">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center pt-0.5">
              <i className="ri-information-line text-base text-secondary-300" />
            </span>
            <span>
              <strong className="font-medium text-background-50">Modelo demonstrativo criado pela Vellora Studio.</strong>{" "}
              A Amora Belle é um conceito de loja de moda feminina para apresentação comercial. Não representa uma loja
              física em funcionamento e não possui dados legais, endereço ou meios de pagamento definidos.
            </span>
          </p>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-4 border-t border-primary-700 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-300">
            © {new Date().getFullYear()} Amora Belle — modelo demonstrativo. Todos os direitos reservados.
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <button
              type="button"
              onClick={() => setPrivacyOpen(true)}
              className="cursor-pointer whitespace-nowrap text-xs text-background-200 transition-colors hover:text-secondary-300"
            >
              Política de privacidade
            </button>
            <Link
              to="/painel"
              className="cursor-pointer whitespace-nowrap text-xs text-background-200 transition-colors hover:text-secondary-300"
            >
              Painel do site
            </Link>
            <a
              href={VELLORA_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer whitespace-nowrap text-xs text-secondary-200 transition-colors hover:text-secondary-300"
            >
              Desenvolvido pela Vellora Studio
            </a>
          </div>
        </div>
      </div>

      <PrivacyModal open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </footer>
  );
}